import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator, 
         initializeFirestore, CACHE_SIZE_UNLIMITED,
         persistentLocalCache, persistentMultipleTabManager,
         memoryLocalCache } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Get configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
console.log('Initializing Firebase...');
const app = initializeApp(firebaseConfig);
console.log('Firebase initialized successfully');

// Determine if we should use persistence based on browser capability
const canUsePersistence = () => {
  try {
    // Check if IndexedDB is available
    return window.indexedDB !== undefined &&
           window.indexedDB !== null &&
           navigator.onLine;
  } catch (e) {
    console.warn('IndexedDB not available, disabling Firestore persistence');
    return false;
  }
};

// Initialize Firestore with appropriate persistence settings
console.log('Initializing Firestore...');
const db = initializeFirestore(app, {
  // Use in-memory cache if persistence isn't available
  localCache: canUsePersistence() 
    ? persistentLocalCache({ 
        cacheSizeBytes: CACHE_SIZE_UNLIMITED,
        tabManager: persistentMultipleTabManager()
      })
    : memoryLocalCache()
});

console.log('Firestore initialized successfully');

// Initialize Auth
console.log('Initializing Auth...');
const auth = getAuth(app);
console.log('Auth initialized successfully');

// Initialize Functions
const functions = getFunctions(app);

// Connect to emulators in development if needed
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  console.log('Connecting to Firebase emulators...');
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

// Export initialized services
export { app, auth, functions, db };
